<article class="main menu-l">
    <aside class="box">
        <h6>Uso y disposición de botones</h6>
        <ul>
            <li><a href="#clases">Clases y uso</a></li>
            <li><a href="#disposicion">Disposición</a></li>
        </ul>
    </aside>
    <main>
        <section id="clases" class="main c11">
            <article class="card box no-limit">
                <h2>Clasificación de botones</h2>
                <p>La selección de clases está ligada a la acción que llevará a cabo el mismo y el fujo de acción de la aplicación.
                <code> &lt;button clas="btn class"&gt; Acción &lt;/button&gt;</code></p>
                <table class="table tigh">
                    <thead><tr class="alert alert-primary"> <td >Principal</td><td>class: primary</td> </tr></thead>
                    <tbody> <tr>
                            <td>[ Aceptar, Continuar ]</td><td >Permite el flujo de acción, graba en base o impacta una acción en el flujo normal de trabajo</td>
                        </tr>
                    </tbody>
                    <thead><tr class="alert alert-danger">  <td >Cancelación</td><td>class: danger</td>  </tr></thead>
                    <tbody> <tr>
                            <td>[ Cancelar, Eliminar ]</td><td>Corte de ejecución, una acción que tiene efecto que requiere atención (por eliminación o perdida de contenido), se recomienda usar un modal de confirmación al llamar a la acción</td>
                        </tr>
                    </tbody>
                    <thead><tr class="alert alert-secondary"> <td >Secundario</td><td>class: secondary</td> </tr></thead>
                    <tbody> <tr>
                            <td>[ Volver, Cancelar, Ver ... ]</td><td >Acciones secundarias que no requieran confirmación, realizar una acción adicional o regresar sin afectar ejecución</td>
                        </tr>
                    </tbody>
                    <thead><tr class="alert alert-gris-claro"> <td >Secundario</td><td>class: gris-claro</td> </tr></thead>
                    <tbody> <tr>
                            <td>[ Imprimir, Ver ... ]</td><td >Para acciones de poca relevancia, o satélites que no afectan el flujo de trabajo se puede usar una cuarta clasificación, siempre al final de la lista de acciones</td>
                        </tr>
                    </tbody>
                </table>
            </article>
            <article class="card box no-limit">
                <h4>Uso de #tag button</h4>
                <p class="alert alert-danger"><b>No se aconseja su uso</b><br/>
                    No se recomienda la inclusión de múltiples colores para no generar ruido visual y confusión. 
                    "Si todo destaca, nada destaca". Por esta razón es recomedable solo utilizar las clases mencionadas anteriormente
                </p>
                <p>En caso excepcionales donde sea necesario disponed de más colores para relacionar acciones con estados/atributos. se puede ustilizar la clase 'tag-n' junto a 'btn' para disponer de un abanido mayor de colores armónicos </p>
                <div >
                    <p><code> &lt;button class="btn tag-1"&gt;#tag-1&lt;/button&gt;</code></p>
                    <div class="botonera-inferior">
                        <button class="btn tag-1">#tag-1</button>
                        <button class="btn tag-2">#tag-2</button>
                        <button class="btn tag-3">#tag-3</button>
                        <button class="btn tag-10">#tag-10</button>
                        <button class="btn tag-11">#tag-11</button>
                        <button class="btn tag-12">#tag-12</button>
                    </div>
                    <p>Existen 12 tags/colores disponibles que se aconseja utilizar en orden</p>
                    <div class="botonera-inferior">
                        <button class="btn tag-1">#tag-1</button>
                        <button class="btn tag-3">#tag-3</button>
                        <button class="btn tag-5">#tag-5</button>
                        <button class="btn tag-7">#tag-7</button>
                        <button class="btn tag-9">#tag-9</button>
                        <button class="btn tag-11">#tag-11</button>
                    </div>                    
                    <p>Si se desea mayor contraste entre tags se puede saltear números, pero para mantener la armonía recomiendo no saltear mas de 1 valor</p>
                </div>
            </article>
        </section>
        <article class="card box no-limit">
            <section id="disposicion">
                <h2>Disposición de los botones</h2>
                <p>Existen dos formas para disponer los botones según la construcción del contenido y la cantidad de acciones<br/>
                    Asimismo en ambas se establece que el orden de los botones depende de donde esté establecido el punto de tención del contenedor
                </p>
            </section>
            <h4>Con botoneta inferior</h4>
            <section >
                <p class="alert alert-warning">Se debe mantener la estructura de botones de derecha a izquierda:
                    <br/> << [otras] -[Acción peligrosa] - [Acción principal] </p>
                <p>Se construye armando un div con una botonera fija en la parte inferior, se pueden agrupar todos los botones con un div/section con la clase 
                    <span class="destacado">botonera-inferior</span> para que se posicionen de la forma deseada</p>
                <section class="botonera-inferior">
                    <button class="btn btn-secondary">Acción adicional</button>
                    <button class="btn btn-secondary">Otra Acción</button>
                    <button class="btn btn-danger">Acción peligrosa</button>
                    <button class="btn btn-primary">Principal</button>
                </section>
            </section>
            <h4>Con botoneta lateral</h4>
            <section class="main c11">
                <section >
                    <p class="alert alert-warning">Se debe mantener la estructura de botones de Arriba hacia abajo</p>
                    <p>Cuando se cuenta con demasiados botones o la visualización de la págino lo amerite. 
                        Se puede cambiar el punto de tensión, posicionando la acción prinsipar en el vértica superior (derecho/izquierdo)
                        Esto es recomendable cunado el contenido a mostrar es muy largo y se desea mantener la botonera accesible rápidamente sin tener que escrollear al fondo de l apágina
                        Se construye armando un div con una botonera a uno de los lados el contenido mostrado, se pueden agrupar todos los botones con un div/section con la clase 
                        <span class="destacado">botonera-lateral</span> para que se posicionen de la forma deseada</p>
                    <div class="alert alert-secondary">
                        Nota: Se recomienda colocar el contenido y la botonera dentro un div con clase "main c11" <br/>
                        <code>
                            <p>< div class="main c11"> <br/>
                            < div > contenido < / div> <br/>
                            < div class="botonera-lateral"> botonera < / div> <br/>
                            < / div ></p>
                        </code>
                    </div>
                </section>
                <section class="botonera-lateral">
                    <button class="btn btn-primary">Principal</button>
                    <button class="btn btn-danger">Acción peligrosa</button>
                    <button class="btn btn-secondary">Acción adicional</button>
                    <button class="btn btn-secondary">Otra Acción</button>
                    <button class="btn btn-gris-claro">Opcional: baja relevancia</button>
                </section>
            </section>
        </article>
    </main>
</article>
